import React from "react";
import dayjs from "dayjs";
import CalendarIcon from "../../../../../../Common/Svgs/CalendarIcon";
import InfoCircleIcon from "../../../../../../Common/Svgs/InfoCircleIcon";
import getScheduleStatus from "./getScheduleStatus";
import { TIME_OFF_STATUS } from "./constants";

const TimeoffCard = ({
  hideName = false,
  item,
  handleReject,
  handleApprove,
  tripsCount,
  sessionsCount,
}) => {
  const getSubtext = () => {
    switch (item?.status) {
      case TIME_OFF_STATUS.PENDING:
        return (
          <div className="flex items-center gap-x-1.5 max-h-max mt-1.5">
            {!hideName && (
              <p className="font-aileron text-xs font-semibold text-dark-gray capitalize">
                {item.name}
              </p>
            )}

            {!hideName && <div className="w-px h-[10px] bg-dark-gray" />}

            <p className="font-aileron text-xs font-semibold text-dark-gray">
              Applied on {dayjs(item.appliedOn).format("DD MMM")}
            </p>

            <div className="w-px h-[7px] bg-dark-gray" />

            <p className="font-aileron text-xs font-semibold text-dark-gray uppercase">
              {dayjs(item.appliedOn).format("hh:mm a")}
            </p>
          </div>
        );

      case TIME_OFF_STATUS.APPROVED:
        return (
          <div className="flex items-center gap-x-1.5 max-h-max mt-1.5">
            <p className="font-aileron text-xs font-semibold text-dark-gray">
              Approved By {item.updatedBy}
            </p>
            <div className="w-px h-[7px] bg-dark-gray" />

            <p className="font-aileron text-xs font-semibold text-dark-gray uppercase">
              {dayjs(item.updatedAt).format("hh:mm a")}
            </p>
          </div>
        );

      case TIME_OFF_STATUS.REJECTED:
        return (
          <div className="flex items-center gap-x-1.5 max-h-max mt-1.5">
            <p className="font-aileron text-xs font-semibold text-dark-gray">
              Rejected By {item.updatedBy}
            </p>

            <div className="w-px h-[7px] bg-dark-gray" />

            <p className="font-aileron text-xs font-semibold text-dark-gray uppercase">
              {dayjs(item.updatedAt).format("hh:mm a")}
            </p>
          </div>
        );

      default:
        return <div />;
    }
  };

  return (
    <div>
      <div className="bg-background p-3 border border-light-grey rounded-xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-x-1.5">
            <CalendarIcon size={16} className="stroke-black" />

            <p className="font-poppins text-base font-medium">
              {dayjs(item?.startDate).format("DD MMM")} -{" "}
              {dayjs.utc(item?.endDate).format("DD MMM YYYY")}
            </p>
          </div>

          <div>
            {getScheduleStatus({ type: "timeoff", status: item?.status })}
          </div>
        </div>

        {getSubtext()}

        <div className="my-3">
          <p className="font-aileron text-xs font-semibold text-dark-gray capitalize">
            Note
          </p>

          <div className="mt-1 bg-white rounded-md p-2 font-aileron font-normal text-xs leading-none h-[30px]">
            {item?.notes}
          </div>
        </div>

        {item?.status === TIME_OFF_STATUS.PENDING ? (
          <>
            {tripsCount ? (
              <div className="bg-warning-10 py-1.5 px-2 flex items-center gap-x-1 rounded-md border-[0.5px] border-warning">
                <InfoCircleIcon size={16} />
                <p className="font-aileron font-semibold text-xs">
                  Number of trips assigned: {tripsCount}
                </p>
              </div>
            ) : null}
            {sessionsCount ? (
              <div
                className={`bg-warning-10 py-1.5 px-2 flex items-center gap-x-1 rounded-md border-[0.5px] border-warning ${
                  tripsCount ? "mt-1" : ""
                }`}
              >
                <InfoCircleIcon size={16} />
                <p className="font-aileron font-semibold text-xs">
                  Number of sessions assigned: {sessionsCount}
                </p>
              </div>
            ) : null}
          </>
        ) : null}
      </div>

      {item?.status === TIME_OFF_STATUS.PENDING ? (
        <div className="mt-4 flex justify-end gap-x-3">
          <button
            type="button"
            className="bg-background py-1 px-2 rounded-md h-[28px]"
            onClick={() => handleReject(item.id)}
          >
            <p className="font-poppins font-medium text-xs text-alert-red">
              Reject
            </p>
          </button>

          <button
            type="button"
            className="bg-primary py-1 px-2 rounded-md h-[28px]"
            onClick={() => handleApprove(item)}
          >
            <p className="font-poppins font-medium text-xs text-white">
              Approve
            </p>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default TimeoffCard;
